import { render, staticRenderFns } from "./handleOrders.vue?vue&type=template&id=231d71b9&scoped=true&"
import script from "./handleOrders.vue?vue&type=script&lang=js&"
export * from "./handleOrders.vue?vue&type=script&lang=js&"
import style0 from "./handleOrders.vue?vue&type=style&index=0&id=231d71b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d71b9",
  null
  
)

export default component.exports